import * as React from "react";
import { CurrencySymbolDictionary } from "../../../../../../../../react-core/Enums/Dictionaries/CurrencySymbolDictionary";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { RealisedGainLossColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/RealisedGainLossColumns";
import { RealisedGainLossDetailModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/RealisedGainLossDetailModel";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { ITableConfig, Table } from "../../../../../../../Shared/Table/Table";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { Contents } from "../../Insights/Resource/Contents";
import { StarTooltip } from "../Resource/Contents";

interface IRealisedGainLossTableProps {
    data: RealisedGainLossDetailModel[];
}

export const getRealisedCol = (currencyCode: string): ITableConfig[] => {
    return [
        {
            title: "As at",
            key: "AsAt",
            tableFilter: RealisedGainLossColumns.AsAt,
            render: (data, row, index) => {
                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
            },
            filterOption: { disableEdit: true },
        },
        {
            title: (
                <span>
                    Code
                    <AriaTooltip cssWrapper="is-info-icon ml-5">{StarTooltip}</AriaTooltip>
                </span>
            ),
            filterOption: { disableEdit: true },
            filterTitle: "Code",
            tableFilter: RealisedGainLossColumns.Code,
            key: "InstrumentCode",
        },
        {
            title: "Description",
            key: "InstrumentName",
            tableFilter: RealisedGainLossColumns.Description,
            filterOption: { disableEdit: true },
        },
        {
            title: "Qty sold",
            key: "QuantitySold",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            filterOption: { disableEdit: true },
            tableFilter: RealisedGainLossColumns.QtySold,
        },
        {
            title: "Cost",
            key: "Cost",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            tableFilter: RealisedGainLossColumns.Cost,
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
        },
        {
            title: `Cost ${currencyCode}`,
            key: "CostInBaseCurrency",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                return data.Amount.toFixed(4);
            },
            filterOption: { disableEdit: true },
            tableFilter: RealisedGainLossColumns.CostGBP,
        },
        {
            title: "Sale price",
            key: "SalePrice",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data: number, row, index) => {
                return data.toFixed(4);
            },
            tableFilter: RealisedGainLossColumns.SalePrice,
        },
        {
            title: `Sale price ${currencyCode}`,
            key: "SalePriceInBaseCurrency",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                return data.Amount.toFixed(4);
            },
            filterOption: { disableEdit: true },
            tableFilter: RealisedGainLossColumns.SalePriceGBP,
        },
        {
            title: `Realised ${currencyCode}`,
            key: "RealisedInBaseCurrency",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            render: (data, row, index) => {
                return data.Amount.toFixed(4);
            },
            filterOption: { disableEdit: true },
            tableFilter: RealisedGainLossColumns.RealisedGBP,
        },
    ];
};
export const RealisedGainLossTable = (props: IRealisedGainLossTableProps) => {
    if (!props.data) {return null;}
    if (props.data.length == 0) {return <Alert alertType={AlertType.Warning} message={Contents.noDataErrorMessage} />;}

    const [currentPage, setCurrentPage] = React.useState(1);
    const [tableData, setTableData] = React.useState(props.data.slice(0, 49));
    const currencyCode = CurrencySymbolDictionary.getStringMap(props.data[0].CostInBaseCurrency.Currency);
    return (
        <Table
            data={tableData}
            colEditorKey={"RealisedGainLossColumnSettings"}
            col={getRealisedCol(currencyCode)}
            TotalBody={[
                { data: "Total", colIndex: 0 },
                {
                    data: props.data.reduce((sum, ele) => sum + ele.RealisedInBaseCurrency.Amount, 0).toFixed(4),
                    colIndex: 8,
                    tfTdCssWrapper: "cell-right",
                },
            ]}
            needPagination={{
                pageSize: 50,
                totalNumOfResult: props.data.length,
                isShowPerPageOptions: true,
                onPaginationChange: (pageIndex, pageSize) => {
                    const max = pageIndex * pageSize - 1;
                    const min = pageSize * (pageIndex - 1);
                    setCurrentPage(pageIndex);
                    setTableData(props.data.slice(min, max));
                },
                currentPage: currentPage,
            }}
        />
    );
};
